import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class UserService {
  async getProfile() {
    return BaseService.get(API_ENDPOINTS.USER.PROFILE);
  }

  async updateAccountInfo(data) {
    return BaseService.put(API_ENDPOINTS.USER.ACCOUNT_INFO, data);
  }

  async changePassword(payload) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CHANGE_PASSWORD, payload);
  }

  async getCalculations(params = {}) {
    return BaseService.get(API_ENDPOINTS.USER.CALCULATIONS, params);
  }

  async getPurchasedIdeas(params = {}) {
    return BaseService.get(API_ENDPOINTS.USER.PURCHASED_IDEAS, params);
  }

  async getWallet() {
    return BaseService.get(API_ENDPOINTS.USER.WALLET);
  }

  async getMembership() {
    return BaseService.get(API_ENDPOINTS.USER.MEMBERSHIP);
  }

  async deleteAccount() {
    return BaseService.delete(API_ENDPOINTS.USER.ACCOUNT);
  }

  async uploadAvatar(file) {
    return BaseService.uploadFile(API_ENDPOINTS.USER.UPLOAD_AVATAR, file, 'avatar');
  }

  async getAvatar() {
    return BaseService.get(API_ENDPOINTS.USER.AVATAR);
  }

  async deleteAvatar() {
    return BaseService.delete(API_ENDPOINTS.USER.DELETE_AVATAR);
  }
}

export default new UserService();
